"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnwrapTransferBaseTokenRecipe = void 0;
const unwrap_base_token_step_1 = require("../../steps/adapt/unwrap-base-token-step");
const recipe_1 = require("../recipe");
const transfer_base_token_step_1 = require("../../steps/adapt/transfer-base-token-step");
const min_gas_limits_1 = require("../../models/min-gas-limits");
class UnwrapTransferBaseTokenRecipe extends recipe_1.Recipe {
    config = {
        name: 'Unwrap Base Token and Transfer',
        description: 'Unwraps wrapped token into base token, and transfers base token to an external public address.',
        minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_TRANSFER,
    };
    toAddress;
    amount;
    constructor(toAddress, amount) {
        super();
        this.toAddress = toAddress;
        this.amount = amount;
    }
    supportsNetwork() {
        return true;
    }
    async getInternalSteps() {
        return [
            new unwrap_base_token_step_1.UnwrapBaseTokenStep(this.amount),
            new transfer_base_token_step_1.TransferBaseTokenStep(this.toAddress),
        ];
    }
}
exports.UnwrapTransferBaseTokenRecipe = UnwrapTransferBaseTokenRecipe;
